import { SquadCreate } from '#src/components/squad/SquadCreate/index.tsx';

const SquadCreatePage = () => {
  return <SquadCreate />;
};
export default SquadCreatePage;
